/**
 * displays store location cards  list  in columns
 *
 * @module views/components/StoresList
 * @memberof -Common
 */
import './StoresList.scss';

import React from 'react';

import PropTypes from 'prop-types';

import StoreListItem from '@ulta/components/StoreListItem/StoreListItem';

/**
 * Represents a StoresList component
 *
 * @method
 * @param { StoresListProps} props - React properties passed from composition
 * @returns StoresList
 */
export const StoresList = function( props ){
  const { items, componentKey } = props;
  if( !props.items ){
    return null;
  }
  return (
    <div className='StoresList'>
      <div className='StoresList__wrapper'>
        <div className='StoresList__content'>
          <ul className='StoresList__cards'>
            { items?.map( ( storeCard, index )=>(
              <li key={ `${componentKey}-storelist-${index}` }>
                <StoreListItem
                  name={ storeCard.cityName }
                  address1={ storeCard.address1 }
                  address2={ storeCard.address2 }
                  hideRadioButton={ true }
                  storeName={ storeCard.storeName }
                  stateName={ storeCard.stateName }
                  isOpenLabel={ storeCard.couponValidity }
                  storeHoursLabel={ storeCard.couponValidityLabel }
                  isEnabled={ true }
                  emphasize={ true }
                />
              </li>
            ) ) }
          </ul>
        </div>
      </div>
    </div>
  );

};

/**
 * Property type definitions
 * @typedef StoresListProps
 * @type {object}
 * @property {array} items - array of store cards details
 * @property {object} items - object of store cards details
 * @property {string} cityName - city of store location
 * @property {string} address1 - address1 of store location
 * @property {string} address2 - address2 of store location
 * @property {string} storeName - storeName of store location
 * @property {string} stateName - stateName of store location
 * @property {string} couponValidity - couponValidity of store location
 * @property {string} couponValidityLabel - couponValidityLabel of store location
 */
export const propTypes =  {
  items:PropTypes.arrayOf(
    PropTypes.shape( {
      cityName:PropTypes.string,
      address1:PropTypes.string,
      address2:PropTypes.string,
      storeName:PropTypes.string,
      stateName:PropTypes.string,
      couponValidity:PropTypes.string,
      couponValidityLabel:PropTypes.string
    } )
  )
};


StoresList.propTypes = propTypes;

export default StoresList;
